import type { FC } from 'react';
import type { MessageResponse } from '@/entities/conversations';
import { getMessageFeedItemKind } from '../model/feedItem';
import { getMessageContentSource, getMessagePersonName } from '../model/messageText';
import { FeedBubble } from './FeedBubble';
import { MessageContent } from './MessageContent';

type Props = {
  /** Сообщение — клиента, сотрудника, системное или ответ бота */
  message: MessageResponse;
};

/** Сообщение переписки: облако по виду отправителя. */
export const BubbleFeedItem: FC<Props> = ({ message }) => (
  <FeedBubble
    messageId={message.id}
    kind={getMessageFeedItemKind(message)}
    personName={getMessagePersonName(message.person)}
    createdAt={message.createdAt}
  >
    <MessageContent source={getMessageContentSource(message)} attachments={message.attachments} />
  </FeedBubble>
);
